import * as React from "react";
import {useEffect} from "react";
import reservationStore from "../../store/reservationStore";
import api from "../../utils/api";
import Top from "../Top";
import Bottom from "../Bottom";
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import * as util from "../../utils/util";
import {getDayOfWeek} from "../../utils/util";
import {useLocation, useNavigate} from 'react-router-dom';
import StateMissingFallback from "../../components/StateMissingFallback";

const reservationType = {
  packageHospitalName: '', ipDate: '', reservationFirstWishDate: ''
  , familyGrade: '', familyName: '', familyAddress: '', familyPhone: '', familyBirthDate: '', familyBuildingNum: ''
  , packageName: '', packageServiceName: '', piiClassList: [], piiLists: {}
  , additionalPrice: 0, companySupportPrice: 0, customerPayedPrice: 0, packagePrice: 0, rebatePrice: 0
  , reservationStatus: { code: '', name: '' }, reservationTime: '', companyType: ''
};

const SetFinishDetail = (props: any) => {
  const navigate = useNavigate();
  const storeData: any = reservationStore();
  const [uniqueKeys, setUniqueKeys] = React.useState([]);
  const { state } = useLocation();
  const { hoImage, rsvId } = state ?? {};
  const [reservation, setReservation] = React.useState(reservationType);
  const location = useLocation();

  useEffect(() => {
    // 예약 상세
    api.post('master/api/v1/M003003_REQ_RES', { reservationId: rsvId }).then((res: any) => {
      setReservation(res.data.data);
    }).catch(function (error: any) {
      console.log(error)
    });

    // 선택항목
    const keys = storeData.checkedInjectioList.map((v: any) => v.ipClass);
    setUniqueKeys(keys.filter((value: any, index: any, self: any) => self.indexOf(value) === index));
  }, []);



  // state 없이 진입하면(새로고침·직접 URL 접근) 렌더할 데이터가 없다.
  // 아래에서 undefined 의 속성을 읽어 화면이 깨지므로 렌더하지 않는다.
  // state 가 없으면 백지 대신 빠져나갈 수 있는 안내를 보여준다
  if (!state) {
    return (
      <StateMissingFallback
        title="예약 상세"
        message={'예약 정보를 불러오지 못했습니다.\n예약 현황에서 다시 선택해 주세요.'}
        actionLabel="예약 현황으로"
        to="/MyPage/ReservationView"
      />
    );
  }

  return (
    <Container sx={{ bgcolor: '#F6F6F6', minWidth: 320, p: 0, pb: 5 }}>
      <Top title="예약 상세보기" />


      <Box sx={{ p: 3, pb: 5, pt: 12, }}>


        <Card sx={{ m: '0 auto', bgcolor: '#fff', boxSizing: 'border-box', borderRadius: '20px' }}>
          <CardMedia
            component="img"
            sx={{ height: 200, borderRadius: '20px 20px 0 0', bgcolor: '#fff' }}
            src={hoImage}
            title="img"
          />
          <Box sx={{ width: '100%', mt: 1, p: 1, pb: 0, boxSizing: 'border-box' }}>
            <Typography variant="body1" color="#666" fontWeight={700} fontSize={18} align="center" sx={{}}>
              {reservation.packageHospitalName}
            </Typography>
            <Typography variant="body1" color="#666" fontWeight={700} fontSize={16} align="center" sx={{ mt: 1 }}>
              {util.strNull(reservation.ipDate) !== '' ? reservation.ipDate : reservation.reservationFirstWishDate + '(' + getDayOfWeek(reservation.reservationFirstWishDate) + ')'}
              {reservation.reservationTime == '0' ? '' : ` ${String(reservation.reservationTime).slice(0, -2)}:${String(reservation.reservationTime).slice(-2)}`}
              <Typography component={'span'} sx={{ fontSize: 12, color: '#999', ml: 1 }}>{util.strNull(reservation.ipDate) !== '' ? '예약 확정일' : '예약 희망일'}</Typography>
            </Typography>
            <Divider component="div" sx={{ mt: 3, fontSize: 14, color: '#777' }} />

          </Box>

          {/* <Typography color="#666" fontWeight={700} fontSize={16} align="center" sx={{bgcolor: '#f18322', p:1.5, color:'#fff' }}>
              예약 확정
            </Typography> */}
          <Typography color="#666" fontWeight={700} fontSize={16} align="center" sx={{ p: 1.5, color: '#f18322' }}>
            {reservation.reservationStatus.name}
          </Typography>
        </Card>

        <Divider component="div" sx={{ mt: 3, mb: 3, fontSize: 14, color: '#777' }}>예약자 정보</Divider>

        <Card sx={{ m: '0 auto', bgcolor: '#fff', boxSizing: 'border-box', borderRadius: 5 }}>

          <Box sx={{ p: 3 }}>
            <Stack direction={'row'} sx={{ mb: 1.5 }}>
              <Typography sx={{ flex: 1, fontSize: 14, color: '#777' }}>예약자</Typography>
              <Typography sx={{ flex: 2, fontSize: 14, fontWeight: 700 }}>{reservation.familyName} <Typography component={'span'} sx={{ fontSize: 14, color: '#555' }}>{`(${reservation.familyGrade})`}</Typography> </Typography>
            </Stack>
            <Stack direction={'row'} sx={{ mb: 1.5 }}>
              <Typography sx={{ flex: 1, fontSize: 14, color: '#777' }}>생년월일</Typography>
              <Typography sx={{ flex: 2, fontSize: 14 }}>{reservation.familyBirthDate}</Typography>
            </Stack>
            <Stack direction={'row'} sx={{ mb: 1.5 }}>
              <Typography sx={{ flex: 1, fontSize: 14, color: '#777' }}>연락처</Typography>
              <Typography sx={{ flex: 2, fontSize: 14 }}>{reservation.familyPhone}</Typography>
            </Stack>
            <Stack direction={'row'}>
              <Typography sx={{ flex: 1, fontSize: 14, color: '#777' }}>주소</Typography>
              <Typography sx={{ flex: 2, fontSize: 14 }}>{reservation.familyAddress + reservation.familyBuildingNum}</Typography>
            </Stack>
          </Box>

        </Card>

        <Divider component="div" sx={{ mt: 3, mb: 3, fontSize: 14, color: '#777' }}>검진 정보</Divider>

        <Card sx={{ m: '0 auto', bgcolor: '#fff', boxSizing: 'border-box', borderRadius: 5 }}>

          <Box sx={{ p: 3 }}>
            <Stack direction={'row'} sx={{ mb: 1.5 }}>
              <Typography sx={{ flex: 1, fontSize: 14, color: '#777' }}>검진유형</Typography>
              <Typography sx={{ flex: 2, fontSize: 14, fontWeight: 700 }}>{reservation.packageName}</Typography>
            </Stack>

            {reservation.piiClassList && reservation.piiClassList.sort().map((item: any, index: any) => (
              <Stack direction={'row'} sx={{ mb: 1.5 }}>
                <Typography sx={{ flex: 1, fontSize: 14, color: '#777' }}>{item}</Typography>
                <Typography sx={{ flex: 2, fontSize: 14 }}>
                  {Object.values(reservation.piiLists).flat().filter((vv: any) => util.strNull(vv.class) === item).map((v: any) => v.name).join(', ')}
                </Typography>
              </Stack>
            ))}
          </Box>

        </Card>

        <Divider component="div" sx={{ mt: 3, mb: 3, fontSize: 14, color: '#777' }}>결제 정보 </Divider>

        <Card sx={{ m: '0 auto', mb: 0, bgcolor: '#fff', boxSizing: 'border-box', borderRadius: 5, pl: 1, pr: 1 }}>

          <Box sx={payBoxStyle}>
            <List sx={payListStyle}>
              {
                reservation.companyType === 'B2C' || reservation.packageServiceName == '심리상담'
                    ?<ListItem >
                      기본 비용
                    </ListItem>
                    : null
              }
              {/*<ListItem >*/}
              {/*  기본 비용*/}
              {/*</ListItem>*/}
              <ListItem>
                추가 비용
              </ListItem>
            </List>

            <List sx={payStyle} className="pay">
              {
                reservation.companyType === 'B2C' || reservation.packageServiceName == '심리상담'
                    ? <ListItem>
                      {util.formatComma(reservation.packagePrice)} 원
                    </ListItem>
                    : null
              }
              <ListItem >
                {util.formatComma(reservation.additionalPrice)} 원
              </ListItem>
            </List>
          </Box>

          <Divider component="div" sx={{ mt: 2, mb: 2 }} />

          <Box sx={payBoxStyle}>
            <List sx={payListStyle}>
              {
                reservation.packageServiceName != '심리상담'
                ?<ListItem >
                  회사 지원금
                </ListItem>
                : null
              }
              <ListItem >
                선결제 금액
              </ListItem>
            </List>

            <List sx={payStyle} className="pay">
              {
                reservation.packageServiceName != '심리상담'
                ?<ListItem >
                  {util.formatComma(reservation.companySupportPrice)} 원
                </ListItem>
                : null
              }
              <ListItem >
                {util.formatComma(reservation.rebatePrice)} 원
              </ListItem>
            </List>
          </Box>

          <Divider component="div" sx={{ mt: 2 }} />
          <Divider sx={{ mt: .5 }} />

          <Box sx={{ width: '100%', mt: 2 }}>
            <Typography variant="body1" color="#333" align="center" fontWeight={700} fontSize={16} sx={{ mb: 1 }}>
              (합계) 본인부담금  <Typography component={'span'} fontSize={12}>(VAT 포함)</Typography>
            </Typography>

            {
              reservation.packageServiceName != '심리상담'
                ? <Typography variant="body1" color="#EF8322" fontWeight={700} fontSize={20} align="center" sx={{ mb: 2 }}>
                    {util.formatComma(reservation.customerPayedPrice)} 원
                  </Typography>
                : <Typography variant="body1" color="#EF8322" fontWeight={700} fontSize={20} align="center" sx={{ mb: 2 }}>
                    0 원
                  </Typography>
            }

          </Box>

          <Divider component="div" sx={{ mt: 2 }} />

        </Card>

        <Divider component="div" sx={{ mt: 3, mb: 3, fontSize: 14, color: '#777' }}></Divider>

        <Box sx={BtnStyle}>
          <Button variant="contained" sx={BottomBtnStyle}
            onClick={() => {
              if(location.state.url == 'ReservationBeforeView') navigate('../MyPage/ReservationBeforeView')
              else navigate('../MyPage/ReservationView')
            }}
          >
            확인
          </Button>
        </Box>

      </Box>



      <Bottom />
    </Container>
  );
}

const payBoxStyle = {
  p: 0,
  width: '100%',
  display: 'flex',
  margin: '10px 0',
};

const payListStyle = {
  p: 0,
  width: '65%',
  fontSize: 14,
  color: '#777',
  '& li': { pr: 0 }
};


const payStyle = {
  p: 0,
  width: '100%',
  fontSize: 14,
  fontWeight: 500,
  '& li': { justifyContent: 'flex-end' }

};


const BtnStyle = {
  display: 'flex',
  justifyContent: 'center',
  mt: 3,
  boxSizing: 'border-box',
  pb: 3
};

const BottomBtnStyle = {
  width: '100%',
  bgcolor: '#EF8322',
  fontSize: 18,
  fontWeight: 700,
  borderRadius: '30px', p: 1,
  boxSizing: 'border-box',
  color: '#fff',
  border: '1px solid #ef8322',
  ':hover': {
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
    boxShadow: 'none',
    color: '#fff'
  },
  ':active': {
    boxShadow: 'none',
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
  },
  ':focus': {
    boxShadow: 'none',
  },
};


export default SetFinishDetail;
